const InvestmentTypes = Object.freeze({
  Score: 1,
  Amount: 2,
});

export const InvestmentScoreValue = Object.freeze({
  Low: 1,
  Medium: 2,
  High: 3,
});

export default InvestmentTypes;
